import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/data/content";

export const WhatsAppButton = () => (
    <motion.a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hello Hindi Ganga! I'd like to know more about your classes.")}`}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-float-button"
        aria-label="Chat with us on WhatsApp"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-teal px-5 py-3.5 text-sm font-medium text-cream lift-shadow transition-transform duration-300 hover:-translate-y-1"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    >
        <MessageCircle className="h-5 w-5" />
        <span className="hidden sm:inline">Chat with us</span>
    </motion.a>
);
